// Story BP-6: OneFormBadge watermark clicável com gate por plano.
// Renderizado em FormPublic + FormTypeform (classic + typeform modes).
// - Free: SEMPRE renderiza (ignora `form.settings.showBranding`)
// - Pro/Business: respeita `showBranding !== false` (default ON, togglável)
// - Fail-closed defensive: owner_plan_tier undefined → trata como 'free'
//
// Decisões @po Pax (gate v1.1, 2026-04-17):
// - OQ1: texto "Feito com OneForm" (PT-BR)
// - OQ2: estilo unificado (sem prop variant)
// - OQ4: URL com UTMs (source=form_watermark, medium=referral, campaign=free_tier)
// - OQ6/OQ7: `const tier = ownerPlanTier ?? 'free'; const shouldRender = tier === 'free' || formSettings?.showBranding !== false;`

import React from 'react';
import type { FormSettings } from '../../types/forms';

export type PlanTier = 'free' | 'pro' | 'business';

export interface OneFormBadgeProps {
  /** Plan tier do dono do form (BP-1 expõe via `form.owner_plan_tier`). Undefined/null → fail-closed como 'free'. */
  ownerPlanTier?: PlanTier | null;
  /** Settings do form — usado apenas para tiers Pro/Business (showBranding toggle). Ignored em Free. */
  formSettings?: FormSettings;
}

const BADGE_URL =
  'https://oneform.com.br?utm_source=form_watermark&utm_medium=referral&utm_campaign=free_tier';

export const OneFormBadge: React.FC<OneFormBadgeProps> = ({
  ownerPlanTier,
  formSettings,
}) => {
  // Fail-closed defensive: undefined/null → 'free' (preserva watermark em edge cases)
  const tier: PlanTier = ownerPlanTier ?? 'free';
  const shouldRender = tier === 'free' || formSettings?.showBranding !== false;

  if (!shouldRender) return null;

  return (
    // mobile-ui.6.C C1b: compacto no short (viewport baixo) — nunca escondido (gate por plano, fail-closed)
    <p className="text-center text-xs short:text-[10px] mt-4 short:mt-1 text-neutral-600 opacity-70">
      <a
        href={BADGE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Feito com OneForm — abrir oneform.com.br em nova aba"
        className="hover:text-neutral-400 focus:text-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500/40 rounded-sm transition-colors"
      >
        Feito com <span className="text-primary-400">OneForm</span>
      </a>
    </p>
  );
};
